import { type FC } from 'react';

type Props = {
  width?: number;
  height?: number;
};

export const FAQIcon: FC<Props> = ({ width = 36, height = 36 }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M36.2002 0H0.200195V36H36.2002V0Z" fill="white" fillOpacity="0.01" />
      <path
        d="M16.2285 24.0342C22.3035 24.0342 27.2285 20.0052 27.2285 15.0342C27.2285 10.0632 22.3035 6.03418 16.2285 6.03418C10.1535 6.03418 5.22852 10.0632 5.22852 15.0342C5.23069 16.2324 5.51685 17.413 6.06352 18.4792C6.34568 19.0328 6.687 19.5541 7.08152 20.0342C7.21485 20.1975 6.96385 21.2308 6.32852 23.1342C7.55796 22.7604 8.83198 22.5532 10.1165 22.5182C10.7245 22.8504 11.3602 23.1291 12.0165 23.3512C13.3738 23.8073 14.7966 24.038 16.2285 24.0342Z"
        fill="white"
        stroke="#2F353E"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M24.2002 30C20.3342 30 17.2002 27.538 17.2002 24.5C17.2002 21.462 20.3342 19 24.2002 19C28.0662 19 31.2002 21.462 31.2002 24.5C31.1982 25.2346 31.0159 25.9574 30.6692 26.605C30.4888 26.9448 30.2715 27.2638 30.0212 27.556C29.9359 27.656 30.0955 28.2873 30.5002 29.45C29.716 29.2215 28.9057 29.0952 28.0892 29.074C27.7009 29.2775 27.2962 29.4478 26.8792 29.583C26.0136 29.8618 25.1096 30.0026 24.2002 30Z"
        fill="white"
        stroke="#2F353E"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M15.3447 10.7642C16.6527 10.7642 17.6847 11.1842 18.4407 12.0362C19.1607 12.8402 19.5207 13.9082 19.5207 15.2282C19.5207 16.5122 19.1727 17.5562 18.5007 18.3482C18.8127 18.7562 19.1367 19.1882 19.4487 19.6442L18.5367 20.4362C18.2127 19.9682 17.9007 19.5242 17.5887 19.1162C16.9647 19.4762 16.2087 19.6682 15.3447 19.6682C14.0247 19.6682 12.9927 19.2362 12.2487 18.3962C11.5287 17.5802 11.1807 16.5242 11.1807 15.2282C11.1807 13.9202 11.5287 12.8642 12.2487 12.0482C12.9927 11.1842 14.0247 10.7642 15.3447 10.7642ZM15.3447 12.0002C14.4567 12.0002 13.7727 12.3002 13.2807 12.9002C12.8127 13.4762 12.5847 14.2442 12.5847 15.2282C12.5847 16.2002 12.8127 16.9682 13.2807 17.5442C13.7607 18.1322 14.4567 18.4322 15.3447 18.4322C15.9087 18.4322 16.3887 18.3122 16.7967 18.0842C16.3647 17.5562 15.9567 17.0882 15.5607 16.6682L16.3767 15.8762C16.7967 16.3202 17.2167 16.7882 17.6247 17.2682C17.9367 16.7402 18.1047 16.0562 18.1047 15.2282C18.1047 14.2202 17.8647 13.4282 17.3967 12.8522C16.9167 12.2762 16.2327 12.0002 15.3447 12.0002Z"
        fill="#2F353E"
      />
      <path
        d="M23.5207 21.9312H24.6512L26.9717 28.0002H25.9092L25.3567 26.4787H22.8152L22.2627 28.0002H21.2002L23.5207 21.9312ZM23.1127 25.6627H25.0592L24.1072 23.0022H24.0732L23.1127 25.6627Z"
        fill="#2F353E"
      />
    </svg>
  );
};
